/* Camgard ürün sayfası: yatay kaydırıcı, ölçü hapları, teslimat tarihi. */
(function () {
  if (!customElements.get('cg-scroller')) {
    customElements.define('cg-scroller', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cg-scroller__track');
        this.thumb = this.querySelector('.cg-scroller__thumb');
        if (!this.track || !this.thumb) return;
        const update = () => {
          const t = this.track;
          const ratio = t.clientWidth / Math.max(t.scrollWidth, 1);
          const bar = this.thumb.parentElement;
          bar.hidden = ratio >= 0.999;
          this.thumb.style.width = (ratio * 100) + '%';
          const max = t.scrollWidth - t.clientWidth;
          this.thumb.style.transform = 'translateX(' + (max > 0 ? (t.scrollLeft / max) * (1 / ratio - 1) * 100 : 0) + '%)';
        };
        this.track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    });
  }

  const TR_MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
  const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); if (x.getDay() === 0) x.setDate(x.getDate() + 1); return x; };
  document.querySelectorAll('[data-cg-delivery]').forEach((el) => {
    const now = new Date();
    const a = addDays(now, 2);
    const b = addDays(a, 1);
    el.textContent = a.getMonth() === b.getMonth()
      ? a.getDate() + ' – ' + b.getDate() + ' ' + TR_MONTHS[b.getMonth()]
      : a.getDate() + ' ' + TR_MONTHS[a.getMonth()] + ' – ' + b.getDate() + ' ' + TR_MONTHS[b.getMonth()];
  });

  document.querySelectorAll('[data-cg-pills]').forEach((box) => {
    const section = box.closest('section, .shopify-section') || document;
    const map = JSON.parse(box.querySelector('script[type="application/json"]').textContent);
    const state = { a: box.dataset.a, b: box.dataset.b };
    box.cgState = state;
    // BA-22: snippets/cg-money.liquid ile aynı Türkçe biçim, 159900 -> "1.599,00 TL" (TL öncesi bölünmez boşluk).
    const fmt = (cents) => {
      const c = Math.abs(Math.round(cents));
      const tl = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return (cents < 0 ? '-' : '') + tl + ',' + String(c % 100).padStart(2, '0') + ' TL';
    };
    const paint = () => {
      box.querySelectorAll('[data-g]').forEach((btn) => {
        const g = btn.dataset.g; const v = btn.dataset.v;
        const on = state[g] === v;
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (btn.getAttribute('role') === 'radio') btn.setAttribute('aria-checked', on ? 'true' : 'false');
        const other = g === 'a' ? state.b : state.a;
        const key = g === 'a' ? v + '|' + other : other + '|' + v;
        btn.classList.toggle('is-off', !(map[key] && map[key].ok));
      });
      // Paket kartları: adet başı fiyat + aynı ölçünün 1 adet fiyatına göre kazanç (compare_at kullanılmaz).
      const tiers = box.querySelectorAll('.cg-tier');
      if (!tiers.length) return;
      const one = Array.from(tiers).find((t) => t.dataset.q === '1');
      const base = one && map[state.a + '|' + one.dataset.v];
      tiers.forEach((t) => {
        const e = map[state.a + '|' + t.dataset.v];
        const q = Number(t.dataset.q) || 1;
        const set = (f, txt) => { const el = t.querySelector('[data-f="' + f + '"]'); if (el) { el.textContent = txt; el.hidden = !txt; } };
        if (!e) { set('price', ''); set('unit', ''); set('save', ''); return; }
        set('price', fmt(e.p));
        set('unit', fmt(Math.round(e.p / q)));
        if (base && q > 1) {
          const full = base.p * q; const save = full - e.p;
          set('save', save > 0 ? fmt(save) + ' kazanç · %' + Math.floor((save / full) * 100) : '');
        }
      });
    };
    box.cgEntry = () => map[state.a + '|' + state.b];
    box.cgMoney = fmt; // BA-27: yapışkan çubuk aynı Türkçe biçimi kullanır.
    // BA-24 (yalnız paket kartlı kutu = pencere): Dawn varyant değişince yeni HTML gelene kadar sepete ekle
    // butonunu kapatıyor; o arada yapılan tıklama sessizce kayboluyordu. Kimliği hemen forma yaz, butonu açık tut.
    // BA-32: duşakabinde de (cg-pills--fix).
    const syncForm = (entry) => {
      if (!box.classList.contains('cg-pills--fix') || !entry) return;
      section.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((f) => {
        const inp = f.querySelector('input[name="id"]');
        if (inp) { inp.value = entry.id; inp.disabled = !entry.ok; }
        const sb = f.querySelector('[type="submit"]');
        if (sb && entry.ok) sb.removeAttribute('disabled');
      });
    };
    // BA-28 (yalnız paket kartlı kutu): Dawn varyant değişince galeride setActiveMedia(id, true) çağırıp sayfayı
    // ana görsele kaydırıyor; müşteri dokunduğu kartta kalsın. Aynı işi yapar (görseli öne al, etkinleştir,
    // küçük resmi seç), yalnız sayfayı dikeyde kaydırmaz. Küçük resim tıklaması (prepend=false) Dawn'da kalır.
    // Galeri ProductInfo <section>'ının dışında; Shopify bölüm kabında aranır.
    const gallery = box.classList.contains('cg-pills--fix') &&(box.closest('.shopify-section') || document).querySelector('media-gallery');
    if (gallery) {
      gallery.setActiveMedia = function (mediaId, prepend) {
        if (!prepend || !this.elements) return Object.getPrototypeOf(this).setActiveMedia.call(this, mediaId, prepend);
        const viewer = this.elements.viewer;
        const active = viewer.querySelector('[data-media-id="' + mediaId + '"]') || viewer.querySelector('[data-media-id]');
        if (!active) return;
        viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
        active.classList.add('is-active');
        if (active.parentElement.firstElementChild !== active) active.parentElement.prepend(active);
        const thumbs = this.elements.thumbnails;
        const thumb = thumbs && thumbs.querySelector('[data-target="' + mediaId + '"]');
        if (thumb && thumb.parentElement.firstElementChild !== thumb) thumb.parentElement.prepend(thumb);
        if (viewer.slider && viewer.resetPages) viewer.resetPages();
        if (this.preventStickyHeader) this.preventStickyHeader();
        window.setTimeout(() => { if (!this.mql || !this.mql.matches || thumbs) active.parentElement.scrollTo({ left: active.offsetLeft }); });
        if (this.playActiveMedia) this.playActiveMedia(active);
        if (thumb) { this.setActiveThumbnail(thumb); this.announceLiveRegion(active, thumb.dataset.mediaPosition); }
      };
    }
    box.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-g]');
      if (!btn) return;
      state[btn.dataset.g] = btn.dataset.v;
      let entry = map[state.a + '|' + state.b];
      if (!entry) {
        // Kombinasyon yoksa diğer grubun ilk uygun değerine geç.
        const k = Object.keys(map).find((x) => btn.dataset.g === 'a' ? x.startsWith(state.a + '|') : x.endsWith('|' + state.b));
        if (!k) return;
        [state.a, state.b] = k.split('|'); entry = map[k];
      }
      paint();
      const inputs = section.querySelectorAll('variant-selects input[type="radio"], variant-selects option');
      const target = Array.from(inputs).find((i) => i.value === entry.v);
      if (!target) return;
      if (target.tagName === 'OPTION') { target.selected = true; target.parentElement.dispatchEvent(new Event('change', { bubbles: true })); }
      else { target.checked = true; target.dispatchEvent(new Event('change', { bubbles: true })); }
      syncForm(entry);
    });
    paint();
  });

  // BA-12/16: 2/4 adet paketinde hediye aparat setini (ayrı, 0 TL "aparat-seti-hediye" ürünü) filmle aynı
  // istekte sepete ekle; paket sepetten çıkınca cg-gift.js hediyeyi siler. Hediye zaten sepetteyse ya da 1 adet seçiliyse Dawn'ın akışı çalışır.
  document.addEventListener('submit', async (ev) => {
    const form = ev.target;
    if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;
    if (form.dataset.cgSkip) { delete form.dataset.cgSkip; return; }
    const box = document.querySelector('[data-cg-pills][data-gift]');
    // BA-24: sepete her zaman kartlarda GÖRÜNEN seçim gitsin (hızlı seçimde formdaki kimlik eski kalabiliyordu).
    // BA-32: duşakabinde hediye kutusu yok; seçimi ölçü düğmelerinden al.
    const sel = box || document.querySelector('.cg-pills--fix[data-cg-pills]');
    const cur = sel && sel.cgEntry && sel.cgEntry();
    const idInput = form.querySelector('input[name="id"]');
    if (cur && cur.ok && idInput) { idInput.value = cur.id; idInput.disabled = false; }
    const tier = box && box.querySelector('.cg-tier.is-on');
    if (!tier || Number(tier.dataset.q) < 2) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    const btn = form.querySelector('[type="submit"]');
    const fallback = () => { form.dataset.cgSkip = '1'; form.requestSubmit(btn || undefined); };
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); const s = btn.querySelector('.loading__spinner'); if (s) s.classList.remove('hidden'); }
    const done = () => { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); const s = btn.querySelector('.loading__spinner'); if (s) s.classList.add('hidden'); } };
    try {
      const fd = new FormData(form);
      const id = Number(fd.get('id'));
      const qty = Number(fd.get('quantity')) || 1;
      const gift = Number(box.dataset.gift);
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      const items = [{ id, quantity: qty }];
      if (!cart.items.some((i) => i.variant_id === gift)) items.push({ id: gift, quantity: 1 });
      const drawer = document.querySelector('cart-drawer');
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) { done(); fallback(); return; }
      done();
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.classList.remove('is-empty');
        data.id = id;
        drawer.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: id, cartData: data });
    } catch (e) {
      done();
      fallback();
    }
  }, true);
})();
